<template>
<div class="full-calendar-header">
  <div class="header-left">
    <slot name="header-left">
    </slot>
    <slot name="header-center"></slot>
  </div>
  <div class="header-center">
    <el-button class="prev-month" size="small" @click.stop="goPrev"></el-button>
    <span class="title">{{title}}</span>
    <el-button class="next-month" size="small" @click.stop="goNext"></el-button>
    <!-- @author jeee12 : 오늘 날짜로 이동 -->
    <el-button class="todate" size="small" @click.stop="goToday">오늘</el-button>
  </div>
  <div class="header-right">
    <slot name="header-right">
    </slot>
  </div>
</div>
</template>

<script>
import dateFunc from '@/components/external/vue-fullcalendar/components/dateFunc';
import langSets from '@/components/external/vue-fullcalendar/dataMap/langSets';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WCalendarHeader',
  created() {
    this.dispatchEvent();
  },
  props: {
    currentDate: {},
    lang: {
      type: String,
      default: 'ko',
    },
    firstDay: {
      type: Number || String,
      validator(val) {
        const res = parseInt(val, 10);
        return res >= 0 && res <= 6;
      },
      default: 0,
    },
    titleFormat: {
      type: String,
      default() {
        return langSets[this.lang].titleFormat;
      },
    },
    monthNames: {
      type: Array,
      default() {
        return langSets[this.lang].monthNames;
      },
    },
  },
  data() {
    return {
      title: '',
      // headDate: new Date(),
      headDate: this.currentDate, // @author jeee12 현재가 아닌 특정 날짜를 기준으로 calendar 최초 로드
    };
  },
  watch: {
    currentDate(val) {
      if (!val) return;
      if (this.getDateYearAndMonth(val) === this.getDateYearAndMonth(this.headDate)) return; // 년,월이 같을경우 headDate 값 변경x
      this.headDate = val;
      // this.headDate = JSON.parse(JSON.stringify(val))
    },
    headDate() {
      this.dispatchEvent(); // @author jeee12 추가, 특정 날짜로 이동 시 header title 변경되도록 수정
    },
  },
  methods: {
    goPrev() {
      this.headDate = this.changeMonth(this.headDate, -1);
    },
    goNext() {
      this.headDate = this.changeMonth(this.headDate, 1);
    },
    goToday() {
      // @author jeee12 : 오늘날짜로 이동
      this.headDate = this.changeMonth(new Date(), 0);
    },
    changeMonth(date, num) {
      const dt = new Date(date);
      return new Date(dt.setMonth(dt.getMonth() + num));
    },
    dispatchEvent() {
      this.title = dateFunc.format(this.headDate, this.titleFormat, this.monthNames);

      const startDate = dateFunc.getStartDate(this.headDate);
      const curWeekDay = startDate.getDay();

      // 1st day of this monthView
      let diff = parseInt(this.firstDay, 10) - curWeekDay;
      if (diff) diff -= 7;
      startDate.setDate(startDate.getDate() + diff);

      // the month view is 6*7
      const endDate = dateFunc.changeDay(startDate, 41);

      // 1st day of current month
      const currentDate = dateFunc.getStartDate(this.headDate);

      this.$emit('change', dateFunc.format(startDate, 'yyyy-MM-dd'), dateFunc.format(endDate, 'yyyy-MM-dd'), dateFunc.format(currentDate, 'yyyy-MM-dd'), this.headDate);
    },
    /**
     * [getDateYearAndMonth 날짜 년,월 출력]
     * @author {Yang}
     */
    getDateYearAndMonth(date) {
      return getDateToString(date, 'YYYY-MM');
    },
  },
};
</script>

<style lang="scss">
.full-calendar-header {
    display: flex;
    align-items: center;
    // @author jeee12
    margin-bottom: 20px;
    .header-left {
      flex: 1;
      text-align: left;

      .el-radio-button__inner{
        background-color: #eee; //$palegray
        border-color: #eee; //$palegray
        color: #797979;
      }
      .is-active{
        .el-radio-button__inner{
          color: #fff;
          box-shadow: none;
        }
      }

      .el-button--small{
        height: 28px;
        // line-height: initial;
      }
    }
    .header-right {
      flex: 1;
      text-align: right;
    }
    .header-center {
      position: relative;
      flex: 3;
      text-align: center;

      .title {
        margin: 0 10px;
        font-size: 24px;
        vertical-align: middle;
      }
      .next-month,
      .prev-month {
          cursor: pointer;
      }
      .prev-month,
      .next-month{
        position: relative;
        bottom: 2px;
        background: none;
        border: 0;
        padding: 0;
        display: inline-block;
        width: 20px;
        min-width: 20px;;
        height: 20px;
        vertical-align: middle;
        background: url('../../../assets/img/dataf_arrow.png') no-repeat 0 0;
      }
      .prev-month{
        transform: rotate(-180deg);
      }

      .todate{
        border: 1px solid #e0e0e0; //$selectedgray
        background-color: #fefefe; //$whitegray
        height: 23px;
        line-height: 26px;
        border-radius: 12px;
        color: #6f7374;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/work/components/CalendarHeader.vue